import React, { MouseEventHandler, ReactElement } from 'react';
import PropTypes from 'prop-types';
import { ContextMenuTrigger } from 'react-contextmenu';

type ISimpleRowsContainerProps = { rows: Array<ReactElement>; onMouseUp?: MouseEventHandler<any> };

const SimpleRowsContainer = ({ rows, onMouseUp }: ISimpleRowsContainerProps) => {
  return (
    <div key="rows-container" style={{ paddingBottom: '10px' }} onMouseUp={onMouseUp}>
      {rows}
    </div>
  );
};

const RowsContainer = ({
  rowIdx,
  contextMenu,
  idx,
  contextKey,
  rows,
  onMouseUp,
}: ISimpleRowsContainerProps & { contextMenu?: ReactElement; rowIdx: number; idx: number; contextKey: string }) => {
  const hasContextMenu = contextMenu && React.isValidElement(contextMenu);
  const simpleContainer = <SimpleRowsContainer rows={rows} onMouseUp={onMouseUp} />;

  if (!hasContextMenu) return simpleContainer;

  const newProps = { rowIdx: rowIdx, idx: idx };
  const contextMenuElement = React.cloneElement(contextMenu, newProps);

  // Initialise the context menu if it is available
  return (
    <>
      <ContextMenuTrigger key={`context_menu_trigger_${contextKey}`} id={`context_menu_trigger_${contextKey}`}>
        {simpleContainer}
      </ContextMenuTrigger>
      {contextMenuElement}
    </>
  );
};

export default RowsContainer;
export { SimpleRowsContainer };
